export default {
  // 标签页
  transactionSummary: "交易汇总",
  transactionCounterpart: "交易对手",
  transactionDetails: "交易详情",

  // 搜索表单占位符
  dataSourcePlaceholder: "数据来源",
  directionPlaceholder: "交易方向",
  currencyPlaceholder: "币种",
  targetAddressPlaceholder: "请输入交易对手地址",
  minAmountPlaceholder: "最小金额",
  maxAmountPlaceholder: "最大金额",
  startDatePlaceholder: "开始日期",
  endDatePlaceholder: "结束日期",

  // 按钮
  resetBtn: "重置",
  searchBtn: "查询",
  downloadBtn: "下载数据明细",

  // 数据来源选项
  sourceTypeChain: "链上数据",
  sourceTypeInternal: "平台内部",

  // 交易方向选项
  directionInflow: "充币",
  directionOutflow: "提币",

  // 表格列标题
  columnDirection: "交易方向",
  columnCounterpart: "交易对手",
  columnCurrency: "币种",
  columnQuantity: "交易数量",
  columnTime: "交易时间",
  columnHash: "交易哈希",

  // 提示文本
  maxAmountWarning: "最大金额需≥最小金额",
  totalDataText: "共计",
  dataCountText: "条数据",
  loadingText: "拼命加载中",

  // 空状态
  emptyText: "当前调证文件中未解析到充提交易数据",

  // 下载
  downloadFileName: "数据明细",

  // 消息提示
  copySuccess: "复制成功",

  // Summary 页面特有
  selectTypePlaceholder: "请选择",
  selectTypeTotalQuantity: "总数量",
  selectTypeTotalCount: "交易次数",
  minQuantityPlaceholder: "最小数量",
  maxQuantityPlaceholder: "最大数量",
  maxQuantityWarning: "最大数量需≥最小数量",
  columnTotalCount: "交易次数",
  columnTotalQuantity: "交易总数量",
};
